export default "__VITE_ASSET__CqTesFbK__"